import { EColumnPreferenceOrderType } from '@aqx-core/common/api/user-account-setting';

import {
  EActionClick,
  EAdjustAction,
  ECopyTradeInterestAction,
  EFeaturePopupAction,
  EMixpanelChartSetting,
  EMixpanelDrawingTool,
  EMixpanelEventNames,
  EOrderFieldAction,
  EOrderFieldCancelAction,
  ESignalInterestAction
} from '../../types';

class EventNameHelper {
  public mapIncreaseDecreaseEventName = (action: EAdjustAction) => {
    const actionEventMap: { [key in EAdjustAction]?: EMixpanelEventNames } = {
      [EAdjustAction.PRICE_INCREASED]: EMixpanelEventNames.PRICE_INCREASED,
      [EAdjustAction.PRICE_DECREASED]: EMixpanelEventNames.PRICE_DECREASED,
      [EAdjustAction.VOLUME_INCREASED]: EMixpanelEventNames.VOLUME_INCREASED,
      [EAdjustAction.VOLUME_DECREASED]: EMixpanelEventNames.VOLUME_DECREASED,
      [EAdjustAction.STOP_LIMIT_PRICE_INCREASED]: EMixpanelEventNames.STOP_LIMIT_PRICE_INCREASED,
      [EAdjustAction.STOP_LIMIT_PRICE_DECREASED]: EMixpanelEventNames.STOP_LIMIT_PRICE_DECREASED,
      [EAdjustAction.STOP_LOSS_PRICE_INCREASED]: EMixpanelEventNames.STOP_LOSS_PRICE_INCREASED,
      [EAdjustAction.STOP_LOSS_PRICE_DECREASED]: EMixpanelEventNames.STOP_LOSS_PRICE_DECREASED,
      [EAdjustAction.STOP_LOSS_POINTS_INCREASED]: EMixpanelEventNames.STOP_LOSS_POINTS_INCREASED,
      [EAdjustAction.STOP_LOSS_POINTS_DECREASED]: EMixpanelEventNames.STOP_LOSS_POINTS_DECREASED,
      [EAdjustAction.TAKE_PROFIT_PRICE_INCREASED]: EMixpanelEventNames.TAKE_PROFIT_PRICE_INCREASED,
      [EAdjustAction.TAKE_PROFIT_PRICE_DECREASED]: EMixpanelEventNames.TAKE_PROFIT_PRICE_DECREASED,
      [EAdjustAction.TAKE_PROFIT_POINTS_INCREASED]: EMixpanelEventNames.TAKE_PROFIT_POINTS_INCREASED,
      [EAdjustAction.TAKE_PROFIT_POINTS_DECREASED]: EMixpanelEventNames.TAKE_PROFIT_POINTS_DECREASED
    };
    return actionEventMap[action];
  };

  public mapOrderFieldClickEventName = (action: EOrderFieldAction) => {
    const actionEventMap: { [key in EOrderFieldAction]?: EMixpanelEventNames } = {
      [EOrderFieldAction.ORDER_TYPE_CLICKED]: EMixpanelEventNames.ORDER_TYPE_CLICKED,
      [EOrderFieldAction.VOLUME_CLICKED]: EMixpanelEventNames.VOLUME_CLICKED,
      [EOrderFieldAction.FILL_POLICY_CLICKED]: EMixpanelEventNames.FILL_POLICY_CLICKED,
      [EOrderFieldAction.PRICE_FIELD_CLICKED]: EMixpanelEventNames.PRICE_FIELD_CLICKED,
      [EOrderFieldAction.STOP_LIMIT_PRICE_FIELD_CLICKED]: EMixpanelEventNames.STOP_LIMIT_PRICE_FIELD_CLICKED,
      [EOrderFieldAction.STOP_LOSS_PRICE_FIELD_CLICKED]: EMixpanelEventNames.STOP_LOSS_PRICE_FIELD_CLICKED,
      [EOrderFieldAction.STOP_LOSS_PRICE_FIELD_INCREASED]: EMixpanelEventNames.STOP_LOSS_PRICE_INCREASED,
      [EOrderFieldAction.STOP_LOSS_PRICE_FIELD_DECREASED]: EMixpanelEventNames.STOP_LOSS_PRICE_DECREASED,
      [EOrderFieldAction.STOP_LOSS_POINTS_FIELD_CLICKED]: EMixpanelEventNames.STOP_LOSS_POINTS_FIELD_CLICKED,
      [EOrderFieldAction.STOP_LOSS_POINTS_FIELD_INCREASED]: EMixpanelEventNames.STOP_LOSS_POINTS_INCREASED,
      [EOrderFieldAction.STOP_LOSS_POINTS_FIELD_DECREASED]: EMixpanelEventNames.STOP_LOSS_POINTS_DECREASED,
      [EOrderFieldAction.TAKE_PROFIT_PRICE_FIELD_CLICKED]: EMixpanelEventNames.TAKE_PROFIT_PRICE_FIELD_CLICKED,
      [EOrderFieldAction.TAKE_PROFIT_POINTS_FIELD_CLICKED]: EMixpanelEventNames.TAKE_PROFIT_POINTS_FIELD_CLICKED,
      [EOrderFieldAction.EXPIRY_CLICKED]: EMixpanelEventNames.EXPIRY_CLICKED,
      [EOrderFieldAction.EXPIRY_DATE_CLICKED]: EMixpanelEventNames.EXPIRY_DATE_CLICKED,
      [EOrderFieldAction.EXPIRY_TIME_CLICKED]: EMixpanelEventNames.EXPIRY_TIME_CLICKED,
      [EOrderFieldAction.BUY_BUTTON_CLICKED]: EMixpanelEventNames.BUY_BUTTON_CLICKED,
      [EOrderFieldAction.SELL_BUTTON_CLICKED]: EMixpanelEventNames.SELL_BUTTON_CLICKED
    };
    return actionEventMap[action];
  };

  public mapOrderFieldCancelClickEventName = (action: EOrderFieldCancelAction) => {
    const actionEventMap: { [key in EOrderFieldCancelAction]?: EMixpanelEventNames } = {
      [EOrderFieldCancelAction.ORDER_TYPE_CANCEL_CLICKED]: EMixpanelEventNames.ORDER_TYPE_CANCEL_CLICKED,
      [EOrderFieldCancelAction.FILL_POLICY_CANCEL_CLICKED]: EMixpanelEventNames.FILL_POLICY_CANCEL_CLICKED,
      [EOrderFieldCancelAction.EXPIRY_CANCEL_CLICKED]: EMixpanelEventNames.EXPIRY_CANCEL_CLICKED,
      [EOrderFieldCancelAction.EXPIRY_DATE_CANCEL_CLICKED]: EMixpanelEventNames.EXPIRY_DATE_CANCEL_CLICKED,
      [EOrderFieldCancelAction.EXPIRY_TIME_CANCEL_CLICKED]: EMixpanelEventNames.EXPIRY_TIME_CANCEL_CLICKED
    };
    return actionEventMap[action];
  };

  public mapActionClickEventName = (action: EActionClick) => {
    const actionEventMap: { [key in EActionClick]?: EMixpanelEventNames } = {
      [EActionClick.PAGE_FULL_CHART_CLICKED]: EMixpanelEventNames.PAGE_FULL_CHART_CLICKED,
      [EActionClick.PAGE_PORTRAIT_FULL_CHART_CLICKED]: EMixpanelEventNames.PAGE_PORTRAIT_FULL_CHART_CLICKED,
      [EActionClick.SETTINGS_CLICKED]: EMixpanelEventNames.SETTINGS_CLICKED,
      [EActionClick.ACCOUNT_BALANCE_DROP_DOWN_CLICKED]: EMixpanelEventNames.ACCOUNT_BALANCE_DROP_DOWN_CLICKED,
      [EActionClick.ACCOUNT_BALANCE_TOOLTIP_CLICKED]: EMixpanelEventNames.ACCOUNT_BALANCE_TOOLTIP_CLICKED,
      [EActionClick.SEARCH_CLICKED]: EMixpanelEventNames.SEARCH_CLICKED,
      [EActionClick.SYMBOL_SEARCHED_CLICKED]: EMixpanelEventNames.SYMBOL_SEARCHED_CLICKED,
      [EActionClick.WATCHLIST_CLICKED]: EMixpanelEventNames.WATCHLIST_CLICKED,
      [EActionClick.APPEARANCE_CLICKED]: EMixpanelEventNames.APPEARANCE_CLICKED,
      [EActionClick.APPEARANCE_PREFERENCE_CLICKED]: EMixpanelEventNames.APPEARANCE_PREFERENCE_CLICKED,
      [EActionClick.VIEW_ACCOUNTS_CLICKED]: EMixpanelEventNames.VIEW_ACCOUNTS_CLICKED,
      [EActionClick.LINK_ACCOUNT_CLICKED]: EMixpanelEventNames.LINK_ACCOUNT_CLICKED,
      [EActionClick.CONFIRM_LINK_ACCOUNT_CLICKED]: EMixpanelEventNames.CONFIRM_LINK_ACCOUNT_CLICKED,
      [EActionClick.LINK_ACCOUNT_CONFIRMATION_MODAL_CANCEL_CLICKED]:
        EMixpanelEventNames.LINK_ACCOUNT_CONFIRMATION_MODAL_CANCEL_CLICKED,
      [EActionClick.SPECIFICATIONS_TAB_CLICKED]: EMixpanelEventNames.SPECIFICATIONS_TAB_CLICKED,
      [EActionClick.OPEN_POSITIONS_TAB_CLICKED]: EMixpanelEventNames.OPEN_POSITIONS_TAB_CLICKED,
      [EActionClick.PENDING_ORDERS_TAB_CLICKED]: EMixpanelEventNames.PENDING_ORDERS_TAB_CLICKED,
      [EActionClick.ORDER_HISTORY_TAB_CLICKED]: EMixpanelEventNames.ORDER_HISTORY_TAB_CLICKED,
      [EActionClick.ORDER_HISTORY_ORDERS_DEALS_TAB_CLICKED]: EMixpanelEventNames.ORDER_HISTORY_ORDERS_DEALS_TAB_CLICKED,
      [EActionClick.ONE_CLICK_TRADE_TAB_CLICKED]: EMixpanelEventNames.ONE_CLICK_TRADE_TAB_CLICKED,
      [EActionClick.TRADE_TAB_CLICKED]: EMixpanelEventNames.TRADE_TAB_CLICKED,
      [EActionClick.INDICATORS_CLICKED]: EMixpanelEventNames.INDICATORS_CLICKED,
      [EActionClick.INDICATORS_TOOL_TIP_CLICKED]: EMixpanelEventNames.INDICATORS_TOOL_TIP_CLICKED,
      [EActionClick.INDICATORS_SELECTED]: EMixpanelEventNames.INDICATORS_SELECTED,
      [EActionClick.CHART_TYPE_CLICKED]: EMixpanelEventNames.CHART_TYPE_CLICKED,
      [EActionClick.CHART_TYPE_SELECTED]: EMixpanelEventNames.CHART_TYPE_SELECTED,
      [EActionClick.TIMEFRAME_DROPDOWN_CLICKED]: EMixpanelEventNames.TIMEFRAME_DROPDOWN_CLICKED,
      [EActionClick.TIMEFRAME_SELECTED]: EMixpanelEventNames.TIMEFRAME_SELECTED,
      [EActionClick.TIMEFRAME_MODAL_CANCEL_CLICKED]: EMixpanelEventNames.TIMEFRAME_MODAL_CANCEL_CLICKED,
      [EActionClick.DRAWING_TOOL_SELECTED]: EMixpanelEventNames.DRAWING_TOOL_SELECTED,
      [EActionClick.TREND_LINE_DRAWN]: EMixpanelEventNames.TREND_LINE_DRAWN,
      [EActionClick.DELETE_TREND_LINE_CLICKED]: EMixpanelEventNames.DELETE_TREND_LINE_CLICKED,
      [EActionClick.HORIZONTAL_LINE_DRAWN]: EMixpanelEventNames.HORIZONTAL_LINE_DRAWN,
      [EActionClick.DELETE_HORIZONTAL_LINE_CLICKED]: EMixpanelEventNames.DELETE_HORIZONTAL_LINE_CLICKED,
      [EActionClick.VERTICAL_LINE_DRAWN]: EMixpanelEventNames.VERTICAL_LINE_DRAWN,
      [EActionClick.DELETE_VERTICAL_LINE_CLICKED]: EMixpanelEventNames.DELETE_VERTICAL_LINE_CLICKED,
      [EActionClick.CROSS_LINE_DRAWN]: EMixpanelEventNames.CROSS_LINE_DRAWN,
      [EActionClick.DELETE_CROSS_LINE_CLICKED]: EMixpanelEventNames.DELETE_CROSS_LINE_CLICKED,
      [EActionClick.CHART_SETTING_CLICKED]: EMixpanelEventNames.CHART_SETTING_CLICKED,
      [EActionClick.CHART_RIGHT_CLICKED]: EMixpanelEventNames.CHART_RIGHT_CLICKED,
      [EActionClick.REMOVE_ALL_DRAWINGS_CLICKED]: EMixpanelEventNames.REMOVE_ALL_DRAWINGS_CLICKED,
      [EActionClick.REMOVE_ALL_INDICATORS_CLICKED]: EMixpanelEventNames.REMOVE_ALL_INDICATORS_CLICKED,
      [EActionClick.REMOVE_ALL_INDICATORS_DRAWINGS_CLICKED]: EMixpanelEventNames.REMOVE_ALL_INDICATORS_DRAWINGS_CLICKED,
      [EActionClick.ASK_PRICE_ON_Y_AXIS_CLICKED]: EMixpanelEventNames.ASK_PRICE_ON_Y_AXIS_CLICKED,
      [EActionClick.CLEAR_ALL_TRACK_DETAILS_CLICKED]: EMixpanelEventNames.CLEAR_ALL_TRACK_DETAILS_CLICKED,
      [EActionClick.RESET_CHART_CLICKED]: EMixpanelEventNames.RESET_CHART_CLICKED,
      [EActionClick.EDIT_ORDER_MODAL_CANCEL_CLICKED]: EMixpanelEventNames.EDIT_ORDER_MODAL_CANCEL_CLICKED
    };
    return actionEventMap[action];
  };

  public mapChartSettingItemsClickedEventName = (action: EMixpanelChartSetting) => {
    const actionEventMap: { [key in EMixpanelChartSetting]?: EMixpanelEventNames } = {
      [EMixpanelChartSetting.REMOVE_ALL_DRAWINGS]: EMixpanelEventNames.REMOVE_ALL_DRAWINGS_CLICKED,
      [EMixpanelChartSetting.REMOVE_ALL_INDICATORS]: EMixpanelEventNames.REMOVE_ALL_INDICATORS_CLICKED,
      [EMixpanelChartSetting.REMOVE_ALL_INDICATORS_DRAWINGS]:
        EMixpanelEventNames.REMOVE_ALL_INDICATORS_DRAWINGS_CLICKED,
      [EMixpanelChartSetting.ASK_PRICE_ON_Y_AXIS]: EMixpanelEventNames.ASK_PRICE_ON_Y_AXIS_CLICKED,
      [EMixpanelChartSetting.CLEAR_ALL_TRACK_DETAILS]: EMixpanelEventNames.CLEAR_ALL_TRACK_DETAILS_CLICKED,
      [EMixpanelChartSetting.RESET_CHART]: EMixpanelEventNames.RESET_CHART_CLICKED,
      [EMixpanelChartSetting.CHART_COLOR_SETTING]: EMixpanelEventNames.CHART_COLOR_SETTING,
      [EMixpanelChartSetting.PRICE_ALERTS]: EMixpanelEventNames.PRICE_ALERTS_CLICKED
    };
    return actionEventMap[action];
  };

  public mapCompleteDrawingEventName = (drawingTool: EMixpanelDrawingTool) => {
    const actionEventMap: { [key in EMixpanelDrawingTool]?: EMixpanelEventNames } = {
      [EMixpanelDrawingTool.TREND_LINE]: EMixpanelEventNames.TREND_LINE_DRAWN,
      [EMixpanelDrawingTool.HORIZONTAL_LINE]: EMixpanelEventNames.HORIZONTAL_LINE_DRAWN,
      [EMixpanelDrawingTool.VERTICAL_LINE]: EMixpanelEventNames.VERTICAL_LINE_DRAWN,
      [EMixpanelDrawingTool.CROSS_LINE]: EMixpanelEventNames.CROSS_LINE_DRAWN
    };
    return actionEventMap[drawingTool];
  };

  public mapDeleteDrawingEventName = (drawingTool: EMixpanelDrawingTool) => {
    const actionEventMap: { [key in EMixpanelDrawingTool]?: EMixpanelEventNames } = {
      [EMixpanelDrawingTool.TREND_LINE]: EMixpanelEventNames.DELETE_TREND_LINE_CLICKED,
      [EMixpanelDrawingTool.HORIZONTAL_LINE]: EMixpanelEventNames.DELETE_HORIZONTAL_LINE_CLICKED,
      [EMixpanelDrawingTool.VERTICAL_LINE]: EMixpanelEventNames.DELETE_VERTICAL_LINE_CLICKED,
      [EMixpanelDrawingTool.CROSS_LINE]: EMixpanelEventNames.DELETE_CROSS_LINE_CLICKED
    };
    return actionEventMap[drawingTool];
  };

  public mapFeaturePopupAction = (action: EFeaturePopupAction) => {
    const actionEventMap: { [key in EFeaturePopupAction]?: EMixpanelEventNames } = {
      [EFeaturePopupAction.FEATURE_POPUP_TRY_IT_NOW_CLICKED]: EMixpanelEventNames.FEATURE_POPUP_TRY_IT_NOW_CLICKED,
      [EFeaturePopupAction.FEATURE_POPUP_GOT_IT_CLICKED]: EMixpanelEventNames.FEATURE_POPUP_GOT_IT_CLICKED
    };
    return actionEventMap[action];
  };

  public mapSignalInterestEventName = (action: ESignalInterestAction) => {
    const actionEventMap: { [key in ESignalInterestAction]?: EMixpanelEventNames } = {
      [ESignalInterestAction.SIGNAL_EXPRESS_INTEREST]: EMixpanelEventNames.SIGNAL_EXPRESS_INTEREST,
      [ESignalInterestAction.SIGNAL_INTEREST_SUBMITTED]: EMixpanelEventNames.SIGNAL_INTEREST_SUBMITTED
    };
    return actionEventMap[action];
  };

  public mapAssetsOrderTabToClickEventName = (tab: EColumnPreferenceOrderType) => {
    const tabEventMap: Partial<Record<EColumnPreferenceOrderType, EActionClick>> = {
      [EColumnPreferenceOrderType.OPEN_POSITION]: EActionClick.OPEN_POSITIONS_TAB_CLICKED,
      [EColumnPreferenceOrderType.PENDING_ORDER]: EActionClick.PENDING_ORDERS_TAB_CLICKED,
      [EColumnPreferenceOrderType.ORDER_HISTORY]: EActionClick.ORDER_HISTORY_TAB_CLICKED,
      [EColumnPreferenceOrderType.ORDERS_AND_DEALS]: EActionClick.ORDER_HISTORY_ORDERS_DEALS_TAB_CLICKED
    };
    return tabEventMap[tab];
  };

  public mapCopyTradeInterestEventName = (action: ECopyTradeInterestAction) => {
    const actionEventMap: { [key in ECopyTradeInterestAction]?: EMixpanelEventNames } = {
      [ECopyTradeInterestAction.COPY_TRADE_EXPRESS_INTEREST]: EMixpanelEventNames.COPY_TRADE_EXPRESS_INTEREST,
      [ECopyTradeInterestAction.COPY_TRADE_INTEREST_SUBMITTED]: EMixpanelEventNames.COPY_TRADE_INTEREST_SUBMITTED
    };
    return actionEventMap[action];
  };
}

const eventNameHelper = new EventNameHelper();
export default eventNameHelper;
